export default __webpack_public_path__ + "images/Tapclicks.d5b53939862d0d18afff2e4816ae82d0.svg";